import { isSP, qs } from '../common/utils'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Sec3_Movie {
  constructor() {
    const el = qs('.p-top-movie')
    if(!el) return

    let isMovieModalOpen = false

    const movie_modal = qs('.p-top-movie-modal')
    const movie_modal_area = qs('.p-top-movie-modal__area')
    const btn_movie_play = qs('.p-top-movie .p-top-movie__btn')
    const btn_modal_close = qs('.p-top-movie-modal__close')
    const movie_player = document.getElementById('modal-movie-player')

    const setMovieSrc = (movie_id) => {
      movie_player.innerHTML = `<iframe class="youtube ga-mediaYoutube-iframe" width="560" height="315" src="https://www.youtube.com/embed/${movie_id}?enablejsapi=1" title="YouTube video player" loading="eager" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen data-modal-video="youtube"></iframe>`
    }

    const showMovieModal = (movie_id) => {
      if(isMovieModalOpen) return
      isMovieModalOpen = true
      
      video.pause()

      setMovieSrc(movie_id)

      document.documentElement.classList.add('no-scroll')
      if(window._lenis) window._lenis.stop()

      const delay = 0.1

      movie_modal.classList.remove('is-hide')

      setTimeout(() => {
        movie_modal.classList.add('is-show')
      }, delay * 1000)
    }

    const hideMovieModal = () => {
      if(!isMovieModalOpen) return
      isMovieModalOpen = false
      
      video.play()

      document.documentElement.classList.remove('no-scroll')
      if(window._lenis) window._lenis.start()

      let delay = 0

      setTimeout(() => {
        movie_modal.classList.add('is-hide')
      }, delay * 1000)

      delay += 0.2

      setTimeout(() => {
        movie_player.innerHTML = ''
      }, delay * 1000)

      delay += 0.3

      setTimeout(() => {
        movie_modal.classList.remove('is-show')
        movie_modal.classList.remove('is-hide')
      }, delay * 1000)
    }

    btn_movie_play.addEventListener('click', () => {
      const movie_id = btn_movie_play.dataset.movieId
      showMovieModal(movie_id)
    })

    movie_modal_area.addEventListener('click', () => {
      hideMovieModal()
    })

    btn_modal_close.addEventListener('click', () => {
      hideMovieModal()
    })

    let xTo
    let yTo

    if(!isSP()) {
      gsap.set(btn_movie_play, {
        x: el.clientWidth / 2,
        y: el.clientHeight / 2,
        xPercent: -50,
        yPercent: -50,
      })

      xTo = gsap.quickTo(btn_movie_play, 'x', { duration: 0.75, ease: 'power3.out' })
      yTo = gsap.quickTo(btn_movie_play, 'y', { duration: 0.75, ease: 'power3.out' })

      el.addEventListener('mousemove', (e) => {
        const rect = el.getBoundingClientRect()
        xTo(e.clientX - rect.left)
        yTo(e.clientY - rect.top)
      })

      el.addEventListener('mouseenter', () => {
        btn_movie_play.classList.remove('is-hide')
      })

      el.addEventListener('mouseleave', () => {
        btn_movie_play.classList.add('is-hide')
      })
    }

    const video = qs('.p-top-movie__video', el)

    const resetMovieBtnPosition = () => {
      btn_movie_play.classList.remove('is-hide')

      if(xTo) {
        const rect = el.getBoundingClientRect()
        xTo(rect.width * 0.5)
        yTo(rect.height * 0.5)
      }
    }

    gsap.fromTo(video,
      { yPercent: -20 },
      {
        yPercent: 20,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
          onLeave: () => {
            if(!isSP()) resetMovieBtnPosition()
          },
          onLeaveBack: () => {
            if(!isSP()) resetMovieBtnPosition()
          },
        },
      }
    )
    
    
    
    // movieエリアでは隠すようにする
    
    
    const header = qs('.c-header')
    if(!header) return
    
    const io = new IntersectionObserver( entries =>
    {
      entries.forEach( entry =>
      {
        if(entry.isIntersecting)
        {
          if(entry.boundingClientRect.top > 0)
          {
            // console.log("下からIN")
          }
          else
          {
            // console.log("上からIN")
            header.dataset.type = "min"
          }
        }
        else
        {
          if(entry.boundingClientRect.top > 0 && entry.intersectionRatio === 0)
          {
            
          }
          else
          {
            // console.log("上へOUT")
            header.dataset.type = "full"
          }
        }
      })
    }, {
      rootMargin: '0% 0% 0% 0%',
      threshold: 0
    })

    io.observe(el)
  }
}
